import { Header } from "../components/Header"
import { MainContent } from "../components/MainContent";
import { ImportantInfo } from "../components/ImportantInfo";
import { Countdown } from "../components/Countdown";
import { CallToStore } from "../components/CallToStore";
import { Maps } from "../components/Maps";
import { Footer } from "../components/Footer";
import { ConfirmationLink } from "../components/ConfirmationLink";

export const Home = () => {

    return (
        <>
            <Header />
            <MainContent />
            <ConfirmationLink />
            <ImportantInfo />
            <Countdown />
            <CallToStore />
            <Maps />
            <Footer />
        </>
    )
}